import React from 'react';

export default function Close48Icon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M23.5 27.5L13 38L10 35L20 25L10 15L13 12L23.5 22.5L34 12L37 15L27 25L37 35L34 38L23.5 27.5Z" fill="currentColor"/>
    </svg>
  );
}
